export default "__VITE_ASSET__BcWA7ll3__"